/***
 * 获取微信Code
 * @param 
 * @returns 重定向
 */
export function getCode() {

    let env = process.env.NODE_ENV =='development'?'local':''
    console.log(process.env.NODE_ENV);
    window.location.href = `https://activity.sznews.com/money/gmxslds2021/index.php?s=index/wechat/start${env}`;
}

/**
 * 获取地址栏参数
 * @param {String} key 获取参数的Key
 * @returns 参数值
 */
export function GetQueryString(key) {
    let _url = window.location.href;
    let _arr = _url.split('?');
    if (_arr.length <= 2) {
        let tmp = _url.split('?')[1]; // ?后为参数数列字符串 形如'a=1&b=2'
        if (!tmp) {
            // console.log('no param');
            return false
        }
        let arr = tmp.split('&'); // ['a=1','b=2']
        let obj = {};
        for (let i = 0; i < arr.length; i++) {
            let _key = arr[i].split('=')[0];
            let _value = arr[i].split('=')[1];
            obj[_key] = _value
        }

        return obj[key]
    } else {
        // 不止一个?号
        let value = '';
        for (let i = 0; i < _arr.length; i++) {
            if (_arr[i].indexOf(key + '=') > -1) {
                //console.log(key + '=' + _arr[i].split('=')[1]);
                value = _arr[i].split('=')[1];
            }
        }
        return value
    }
}




export function checkUserAgent() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return 'ios';
    } else if (/(Android)/i.test(navigator.userAgent)) {
        return 'android';
    } else {
        return 'pc';
    };
}


export function checkAppUserAgent() {
    if (/jzapp\/hdpage/i.test(navigator.userAgent)) {
        return true
    }else {
        return false
    }
}



export function jsbridge(appActionKey, argument) {

   
    return new Promise((resolve, reject) => {
        let agent = checkUserAgent()

        if (agent == 'ios') {
            setupWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler(appActionKey, {
                    'key': argument ?  argument : 'value'
                }, function responseCallback(responseData) {
                    console.log(`JS received response from key ${appActionKey}: ${responseData}`);
                    resolve(responseData)
                })
            });
        } else if (agent == 'android') {
            // let responseData = appActionKey === 'getAppUserInfo' ? appJiaohu.getAppUserInfo('') :  appJiaohu[appActionKey]();
            let responseData = appJiaohu[appActionKey](argument);
            console.log(`JS received response from key ${appActionKey}: ${responseData}`);
            resolve(responseData)
        } else {
            reject('error')
        }

    })
}

export function setupWebViewJavascriptBridge(callback) {
    if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    let WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'https://__bridge_loaded__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe)
    }, 0)
}

// 函数节流
export async function throttle(cb,time=3000){
    let t = null;
    return function () {
        if(t) return;
        t = setTimeout(async () => {
            await cb.call(this);
            t = null;
        }, time);
    }
}